import { initializeBindStatusLazy, linkedInStore } from 'owa-linkedin';
import { lazyExecute3SPrimeCall } from 'owa-substrate-people-suggestions';

export default async function onLinkedInBindWindowClosed() {
    await initializeBindStatusLazy.importAndExecute();
    if ((linkedInStore().status = 'Bound')) {
        // Prime the 3S backend now that the user is bound to LinkedIn
        await lazyExecute3SPrimeCall.importAndExecute(false /*initializeBindStatus*/);
    }
}
